module.exports = {"620201001":"雄关街道","620201002":"钢城街道","620201100":"新城镇","620201101":"峪泉镇","620201102":"文殊镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/620201.json
// module id = 3038
// module chunks = 0